/** Logo depois de abrir ou voltar ao app ainda dá pra recarregar sem atrapalhar. */
const FRESH_MS = 10_000;

/**
 * Registro do service worker (PWA instalável; push e fila offline no M6).
 * Procura versão nova ao abrir e sempre que o app volta pra frente; quando ela assume,
 * recarrega logo se o app acabou de aparecer, senão na próxima vez que sair da tela.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  const sw = navigator.serviceWorker;
  // sem controller = primeira instalação, não há versão velha na tela
  const hadController = !!sw.controller;
  let shownAt = Date.now();
  let pending = false;
  let reloading = false;

  const reload = () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  };

  sw.addEventListener('controllerchange', () => {
    if (!hadController) return;
    pending = true;
    if (document.hidden || Date.now() - shownAt < FRESH_MS) reload();
  });

  window.addEventListener('load', () => {
    sw.register('/sw.js', { type: 'module', scope: '/' })
      .then((reg) => {
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            if (pending) reload();
            return;
          }
          shownAt = Date.now();
          reg.update().catch(() => undefined);
        });
      })
      .catch(() => undefined);
  });
}
